import React, { useEffect, useState } from "react";

const API = "https://smart-bin-backend-zygj.onrender.com";
const token = () => localStorage.getItem("token");
const DEFAULT_MACHINE_ID = "Smart Bin Shredder - BVM";

function AdminDashboard() {
  const [tab, setTab] = useState("overview");
  const [machines, setMachines] = useState([]);
  const [pickups, setPickups]   = useState([]);
  const [weights, setWeights]   = useState([]);
  const [ads, setAds]           = useState([]);
  const [payouts, setPayouts]   = useState([]);
  const [users, setUsers]       = useState([]);
  const [loading, setLoading]   = useState(true);
  const [adForm, setAdForm] = useState({ machineId: DEFAULT_MACHINE_ID, title: "", text: "", imageUrl: "", startTime: "", endTime: "", durationSec: 10 });
  const [adMsg, setAdMsg] = useState("");
  const [uploading, setUploading] = useState(false);
  const [reportFrom, setReportFrom] = useState("");
  const [reportTo,   setReportTo]   = useState("");
  const [editingLocationId, setEditingLocationId] = useState(null);
  const [locationInput, setLocationInput] = useState("");
  const [locationMsg, setLocationMsg] = useState("");
  const [approvalMsg, setApprovalMsg] = useState("");
  const [selectedMachineId, setSelectedMachineId] = useState("");
  const email = localStorage.getItem("email");

  const fetchAll = async () => {
    try {
      const headers = { Authorization: `Bearer ${token()}` };
      const [mRes, pRes, wRes, aRes, pyRes, uRes] = await Promise.all([
        fetch(`${API}/api/machines`, { headers }),
        fetch(`${API}/api/pickups`,  { headers }),
        fetch(`${API}/api/weights`,  { headers }),
        fetch(`${API}/api/ads`,      { headers }),
        fetch(`${API}/api/payouts`,  { headers }),
        fetch(`${API}/api/users`,    { headers }),
      ]);
      const [m, p, w, a, py, u] = await Promise.all([mRes.json(), pRes.json(), wRes.json(), aRes.json(), pyRes.json(), uRes.json()]);
      setMachines(Array.isArray(m) ? m : []);
      setPickups(Array.isArray(p) ? p : []);
      setWeights(Array.isArray(w) ? w : []);
      setAds(Array.isArray(a) ? a : []);
      setPayouts(Array.isArray(py) ? py : []);
      setUsers(Array.isArray(u) ? u : []);
    } catch (err) { console.error(err); } finally { setLoading(false); }
  };

  useEffect(() => { fetchAll(); const interval = setInterval(fetchAll, 15000); return () => clearInterval(interval); }, []);

  // Overview only makes sense for the all-machines view. If a machine
  // gets selected while sitting on Overview, jump to Users instead so
  // the person isn't left looking at a tab that no longer exists.
  useEffect(() => {
    if (selectedMachineId && tab === "overview") {
      setTab("users");
    }
  }, [selectedMachineId, tab]);
  const handleLogout = () => { localStorage.clear(); window.location.href = "/"; };

  const downloadCSV = (type) => {
    const params = new URLSearchParams();
    if (reportFrom) params.append("from", new Date(reportFrom).toISOString());
    if (reportTo)   params.append("to",   new Date(reportTo).toISOString());
    if (selectedMachineId && type !== "payouts") params.append("machineId", selectedMachineId);
    fetch(`${API}/api/reports/${type}?${params.toString()}`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(res => res.blob()).then(blob => { const a = document.createElement("a"); a.href = URL.createObjectURL(blob); const suffix = (selectedMachineId && type !== "payouts") ? `_${selectedMachineId}` : ""; a.download = `rebloc_${type}${suffix}_${new Date().toISOString().slice(0,10)}.csv`; a.click(); })
      .catch(() => alert("Download failed."));
  };

  const istInputToUtcIso = (s) => { if (!s) return ""; return new Date(s + ":00+05:30").toISOString(); };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0]; if (!file) return;
    setUploading(true); setAdMsg("");
    const formData = new FormData(); formData.append("image", file);
    try {
      const res = await fetch(`${API}/api/ads/upload`, { method: "POST", headers: { Authorization: `Bearer ${token()}` }, body: formData });
      const data = await res.json();
      if (res.ok) { setAdForm({ ...adForm, imageUrl: data.url }); setAdMsg("✅ Image uploaded successfully."); }
      else setAdMsg("❌ " + (data.message || "Upload failed."));
    } catch { setAdMsg("❌ Network error during upload."); } finally { setUploading(false); }
  };

  const handleCreateAd = async () => {
    setAdMsg("");
    if (!adForm.title || !adForm.startTime || !adForm.endTime) { setAdMsg("❌ Title, start time and end time are required."); return; }
    try {
      const payload = { ...adForm, startTime: istInputToUtcIso(adForm.startTime), endTime: istInputToUtcIso(adForm.endTime) };
      const res = await fetch(`${API}/api/ads`, { method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` }, body: JSON.stringify(payload) });
      const data = await res.json();
      if (res.ok) { setAdMsg("✅ Ad created: " + data.adId); fetchAll(); setAdForm({ machineId: DEFAULT_MACHINE_ID, title: "", text: "", imageUrl: "", startTime: "", endTime: "", durationSec: 10 }); }
      else setAdMsg("❌ " + (data.message || "Failed"));
    } catch { setAdMsg("❌ Network error"); }
  };

  const handleDeleteAd = async (adId) => { await fetch(`${API}/api/ads/${adId}`, { method: "DELETE", headers: { Authorization: `Bearer ${token()}` } }); fetchAll(); };
  const handlePayoutUpdate = async (payoutId, status) => { await fetch(`${API}/api/payouts/${payoutId}`, { method: "PATCH", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` }, body: JSON.stringify({ status }) }); fetchAll(); };
  const handleRoleChange = async (userId, role) => { try { const res = await fetch(`${API}/api/users/${userId}/role`, { method: "PATCH", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` }, body: JSON.stringify({ role }) }); if (res.ok) fetchAll(); else alert("Failed to update role"); } catch { alert("Network error"); } };
  const handleDeleteUser = async (userId, userEmail) => { if (!window.confirm(`Delete user ${userEmail}?`)) return; await fetch(`${API}/api/users/${userId}`, { method: "DELETE", headers: { Authorization: `Bearer ${token()}` } }); fetchAll(); };

  const startEditingLocation = (machine) => {
    setEditingLocationId(machine.machineId);
    setLocationInput(machine.location || "");
    setLocationMsg("");
  };

  const cancelEditingLocation = () => {
    setEditingLocationId(null);
    setLocationInput("");
    setLocationMsg("");
  };

  const handleSaveLocation = async (machineId) => {
    setLocationMsg("");
    try {
      const res = await fetch(`${API}/api/machines/${encodeURIComponent(machineId)}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
        body: JSON.stringify({ location: locationInput }),
      });
      if (res.ok) {
        setEditingLocationId(null);
        setLocationInput("");
        fetchAll();
      } else {
        const data = await res.json().catch(() => ({}));
        setLocationMsg("❌ " + (data.message || "Failed to save location."));
      }
    } catch {
      setLocationMsg("❌ Network error while saving location.");
    }
  };

  // Approve or reject an operator's proposed location.
  const handleApproveLocation = async (machineId, action) => {
    setApprovalMsg("");
    try {
      const res = await fetch(`${API}/api/machines/${encodeURIComponent(machineId)}/approve-location`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
        body: JSON.stringify({ action }),
      });
      if (res.ok) {
        fetchAll();
      } else {
        const data = await res.json().catch(() => ({}));
        setApprovalMsg("❌ " + (data.message || "Failed to process approval."));
      }
    } catch {
      setApprovalMsg("❌ Network error while processing approval.");
    }
  };

  // Deletes a stale/duplicate machine record entirely.
  const handleDeleteMachine = async (machineId) => {
    if (!window.confirm(`Delete machine "${machineId}"? This cannot be undone.`)) return;
    try {
      const res = await fetch(`${API}/api/machines/${encodeURIComponent(machineId)}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token()}` },
      });
      if (res.ok) fetchAll();
      else alert("Failed to delete machine.");
    } catch {
      alert("Network error while deleting machine.");
    }
  };

  const totalWeight  = parseFloat(weights.reduce((s, w) => s + (w.weightKg || 0), 0).toFixed(3));
  const totalCO2     = parseFloat(weights.reduce((s, w) => s + (w.co2SavedKg || 0), 0).toFixed(3));
  const totalCredits = parseFloat(weights.reduce((s, w) => s + (w.creditsAwarded || 0), 0).toFixed(3));
  const pendingPickups = pickups.filter(p => p.status === "pending").length;
  const pendingPayouts = payouts.filter(p => p.status === "pending").length;
  const unassignedMachines = machines.filter(m => !m.location || m.location.trim() === "").length;
  const pendingApprovals = machines.filter(m => m.locationStatus === "pending_approval");
  const approvedMachines = machines.filter(m => m.locationStatus === "approved");
  const selectedMachine = machines.find(m => m.machineId === selectedMachineId) || null;

  // Weight records for the selected machine, or all records if none selected.
  const scopedWeights = selectedMachineId
    ? weights.filter(w => w.machineId === selectedMachineId)
    : weights;

  // Ads for the selected machine (or ones set to show on ALL machines),
  // or every ad if no machine is selected.
  const scopedAds = selectedMachineId
    ? ads.filter(a => a.machineId === selectedMachineId || a.machineId === "ALL")
    : ads;

  // Users who have at least one weight record at the selected machine.
  // WeightRecord stores userId (a MongoDB ObjectId reference), not an
  // email string, so we match on that -- comparing each user's _id
  // against the userId on scoped weight records. Credits stay
  // pooled/global (confirmed earlier); this is purely "which users
  // have been seen at this machine."
  const scopedUserIds = selectedMachineId
    ? new Set(
        weights
          .filter(w => w.machineId === selectedMachineId)
          .map(w => (typeof w.userId === "object" && w.userId !== null ? w.userId._id || w.userId.toString() : w.userId))
          .filter(Boolean)
      )
    : null;
  const scopedUsers = selectedMachineId
    ? users.filter(u => scopedUserIds.has(u._id))
    : users;

  if (loading) return <div style={styles.loading}>Loading Rebloc Admin...</div>;

  return (
    <div style={styles.bg}><div style={styles.container}>
      <div style={styles.header}>
        <div><h1 style={styles.title}>Rebloc Admin</h1><p style={styles.sub}>{email}</p></div>
        <button style={styles.logoutBtn} onClick={handleLogout}>Logout</button>
      </div>

      <div style={styles.machineSelectorBar}>
        <label style={styles.machineSelectorLabel}>Viewing:</label>
        <select
          style={styles.machineSelectorInput}
          value={selectedMachineId}
          onChange={e => setSelectedMachineId(e.target.value)}
        >
          <option value="">All Machines (global view)</option>
          {approvedMachines.map(m => (
            <option key={m.machineId} value={m.machineId}>
              {m.machineId} — {m.location}
            </option>
          ))}
        </select>
        {selectedMachine && (
          <span style={styles.machineSelectorActive}>
            📍 {selectedMachine.location}
            <StatusPill status={selectedMachine.status} />
          </span>
        )}
      </div>

      {selectedMachineId && (
        <p style={styles.scopeNote}>
          Viewing <strong>{selectedMachineId}</strong> only. <button style={styles.clearScopeBtn} onClick={() => setSelectedMachineId("")}>Back to all machines</button>
        </p>
      )}

      {selectedMachine ? (
        <div style={styles.kpiGroup}>
          <p style={styles.kpiGroupLabel}>{selectedMachineId} snapshot</p>
          <div style={styles.kpiGrid}>
            <KPICard label="Fill"    value={(selectedMachine.fillPercent||0)+"%"}  color={selectedMachine.fillPercent >= 80 ? "#B43232" : "#2E4A3A"} />
            <KPICard label="Current" value={(selectedMachine.currentA||0)+"A"}     color="#2E4A3A" />
            <KPICard label="Temp"    value={(selectedMachine.temperature||0)+"°C"} color="#2E4A3A" />
            <KPICard label="Runtime" value={Math.floor((selectedMachine.runtimeSec||0)/60)+"m"} color="#2E4A3A" />
            <KPICard label="Jams"    value={selectedMachine.jamCount||0}           color={selectedMachine.jamCount > 0 ? "#C49A6C" : "#2E4A3A"} />
            <KPICard label="Users seen here" value={scopedUsers.length}            color="#1a6b3c" />
          </div>
        </div>
      ) : (
        <>
          <div style={styles.kpiGroup}>
            <p style={styles.kpiGroupLabel}>Machines</p>
            <div style={styles.kpiGrid}>
              <KPICard label="Machines"         value={machines.length}          color="#2E4A3A" />
              <KPICard label="Unassigned"       value={unassignedMachines}       color={unassignedMachines > 0 ? "#B43232" : "#2E4A3A"} />
              <KPICard label="Pending Approval" value={pendingApprovals.length}  color={pendingApprovals.length > 0 ? "#C49A6C" : "#2E4A3A"} />
            </div>
          </div>

          <div style={styles.kpiGroup}>
            <p style={styles.kpiGroupLabel}>Impact</p>
            <div style={styles.kpiGrid}>
              <KPICard label="Total Users"    value={users.length}                color="#1a6b3c" />
              <KPICard label="Total Weight"   value={totalWeight.toFixed(3)+"kg"} color="#1a6b3c" />
              <KPICard label="CO₂ Saved"      value={totalCO2.toFixed(3)+"kg"}   color="#0d5c4a" />
              <KPICard label="Weight Records" value={weights.length}              color="#2E4A3A" />
            </div>
          </div>

          <div style={styles.kpiGroup}>
            <p style={styles.kpiGroupLabel}>Needs attention</p>
            <div style={styles.kpiGrid}>
              <KPICard label="Credits Issued"  value={totalCredits.toFixed(3)}          color="#C49A6C" />
              <KPICard label="Pending Pickups" value={pendingPickups}                    color={pendingPickups > 0 ? "#B43232" : "#2E4A3A"} />
              <KPICard label="Pending Payouts" value={pendingPayouts}                    color={pendingPayouts > 0 ? "#B43232" : "#2E4A3A"} />
              <KPICard label="Active Ads"      value={ads.filter(a => a.active).length} color="#C49A6C" />
            </div>
          </div>
        </>
      )}

      <div style={styles.tabRow}>
        {["overview","users","ads","payouts","reports","feedback","energy","analytics"]
          .filter(t => !(selectedMachineId && t === "overview"))
          .map(t => {
          const isScoped = selectedMachineId && (t === "users" || t === "ads" || t === "reports");
          let label;
          if (t === "overview")      label = "Overview";
          else if (t === "users")    label = `Users (${scopedUsers.length})`;
          else if (t === "ads")      label = `Ads (${scopedAds.length})`;
          else if (t === "reports")  label = "Reports";
          else if (t === "feedback") label = "Feedback";
          else if (t === "energy")   label = "Energy";
          else if (t === "analytics") label = "Analytics";
          else                       label = `Payouts${pendingPayouts>0?` (${pendingPayouts})`:""}`;
          return (
            <button key={t} style={{...styles.tabBtn,...(tab===t?styles.tabActive:{})}} onClick={() => setTab(t)}>
              {label}
              {isScoped && <span style={styles.tabScopedDot} title={`Filtered to ${selectedMachineId}`} />}
            </button>
          );
        })}
      </div>

      {tab === "overview" && !selectedMachineId && <>
        {pendingApprovals.length > 0 && (
          <Section title="⏳ Pending Location Approvals">
            {approvalMsg && <p style={{color:"#B43232",fontSize:"13px",marginBottom:"10px"}}>{approvalMsg}</p>}
            {pendingApprovals.map(m => (
              <div key={m.machineId} style={styles.approvalCard}>
                <div style={styles.approvalTop}>
                  <span style={styles.machineId}>{m.machineId}</span>
                  <span style={styles.approvalProposed}>📍 {m.proposedLocation}</span>
                </div>
                <p style={styles.approvalMeta}>
                  Proposed by {m.proposedBy || "unknown"}
                  {m.proposedAt ? " · " + new Date(m.proposedAt).toLocaleString("en-IN") : ""}
                </p>
                <div style={styles.approvalActions}>
                  <button style={{...styles.actionBtn,background:"#1a6b3c"}} onClick={() => handleApproveLocation(m.machineId,"approve")}>✅ Approve</button>
                  <button style={{...styles.actionBtn,background:"#B43232"}} onClick={() => handleApproveLocation(m.machineId,"reject")}>❌ Reject</button>
                </div>
              </div>
            ))}
          </Section>
        )}

        <Section title="🖥 Live Machines">
          {machines.length === 0 ? <p style={styles.empty}>No machines registered yet.</p>
            : machines.map(m => {
              const alerts = [];
              if (m.fillPercent >= 80) alerts.push({ msg: "⚠️ Bin Full — collection needed", color: "#B43232" });
              if (m.currentA > 8)      alerts.push({ msg: "⚡ High Current — possible jam", color: "#B43232" });
              if (m.temperature > 60)  alerts.push({ msg: "🌡️ High Temperature", color: "#C49A6C" });
              if (m.locationStatus === "unassigned")
                alerts.push({ msg: "📍 No location assigned", color: "#C49A6C" });
              if (m.locationStatus === "pending_approval")
                alerts.push({ msg: "⏳ Location pending approval", color: "#C49A6C" });
              if (m.lastHeartbeat && (new Date() - new Date(m.lastHeartbeat)) > 15*60*1000)
                alerts.push({ msg: "📡 Offline — no heartbeat > 15 min", color: "#888" });
              const isEditing = editingLocationId === m.machineId;
              return (
                <div key={m.machineId} style={styles.machineCard}>
                  <div style={styles.machineTop}>
                    <span style={styles.machineId}>{m.machineId}</span>
                    <div style={{display:"flex",gap:"8px",alignItems:"center"}}>
                      <StatusPill status={m.status} />
                      <button style={styles.deleteMachineBtn} onClick={() => handleDeleteMachine(m.machineId)}>Delete</button>
                    </div>
                  </div>

                  {isEditing ? (
                    <div style={styles.locationEditRow}>
                      <input
                        style={styles.locationInput}
                        value={locationInput}
                        onChange={e => setLocationInput(e.target.value)}
                        placeholder="e.g. BVM CoEDM, Vallabh Vidyanagar"
                        autoFocus
                        onKeyPress={e => e.key === "Enter" && handleSaveLocation(m.machineId)}
                      />
                      <button style={styles.locationSaveBtn} onClick={() => handleSaveLocation(m.machineId)}>Save</button>
                      <button style={styles.locationCancelBtn} onClick={cancelEditingLocation}>Cancel</button>
                    </div>
                  ) : (
                    <p style={styles.machineLoc}>
                      📍 {m.location || "No location set"}
                      <button style={styles.editLocationBtn} onClick={() => startEditingLocation(m)}>
                        {m.location ? "Edit" : "Assign directly"}
                      </button>
                    </p>
                  )}
                  {isEditing && locationMsg && <p style={styles.locationMsg}>{locationMsg}</p>}

                  <div style={styles.machineStats}>
                    <Stat label="Fill"    value={(m.fillPercent||0)+"%"} />
                    <Stat label="Temp"    value={(m.temperature||0)+"°C"} />
                    <Stat label="Current" value={(m.currentA||0)+"A"} />
                    <Stat label="Strokes" value={m.strokeCount||0} />
                    <Stat label="Jams"    value={m.jamCount||0} />
                    <Stat label="Runtime" value={Math.floor((m.runtimeSec||0)/60)+"m"} />
                  </div>
                  <FillBar fill={m.fillPercent||0} />
                  <div style={{marginTop:"8px"}}>{alerts.map((a,i) => <div key={i} style={{...styles.alertBadge,background:a.color}}>{a.msg}</div>)}</div>
                  <p style={styles.heartbeat}>Last heartbeat: {m.lastHeartbeat ? new Date(m.lastHeartbeat).toLocaleTimeString("en-IN") : "Never"}</p>
                </div>
              );
            })
          }
        </Section>
        <Section title="🚛 Pickup Requests">
          {pickups.length === 0 ? <p style={styles.empty}>No pickup requests yet.</p>
            : pickups.slice(0,10).map(p => (
              <div key={p._id} style={styles.pickupRow}>
                <div><span style={styles.pickupId}>{p.pickupId}</span><span style={styles.pickupMachine}> · {p.machineId} · {p.reason}</span></div>
                <StatusPill status={p.status} />
              </div>
            ))
          }
        </Section>
        <Section title="⚖️ Recent Weight Records">
          {weights.length === 0 ? <p style={styles.empty}>No weight records yet.</p>
            : weights.slice(0,10).map(w => (
              <div key={w._id} style={styles.weightRow}>
                <div><span style={styles.mfid}>{w.mfid}</span><span style={styles.weightMat}> · {w.materialType}</span></div>
                <div style={styles.weightRight}>
                  <span style={styles.weightKg}>{(w.weightKg||0).toFixed(3)} kg</span>
                  <span style={styles.weightCo2}>{(w.co2SavedKg||0).toFixed(3)} kg CO₂</span>
                </div>
              </div>
            ))
          }
        </Section>
      </>}

      {tab === "users" && <>
        <Section title={selectedMachineId ? `👥 Users at ${selectedMachineId}` : "👥 User Management"}>
          {scopedUsers.length === 0 ? <p style={styles.empty}>{selectedMachineId ? "No users have deposited at this machine yet." : "No users found."}</p>
            : scopedUsers.map(u => (
              <div key={u._id} style={styles.userCard}>
                <div style={styles.userTop}>
                  <div>
                    <p style={styles.userEmail}>{u.email}</p>
                    <p style={styles.userMeta}>{(u.credits||0).toFixed(3)} credits · {(u.totalWeight||0).toFixed(3)} kg · {u.plasticItems||0} items</p>
                  </div>
                  <StatusPill status={u.role||"user"} />
                </div>
                <div style={styles.userActions}>
                  <span style={styles.roleLabel}>Set role:</span>
                  {["user","operator","admin"].map(role => (
                    <button key={role} style={{...styles.roleBtn,background:u.role===role?"#2E4A3A":"#f0f0f0",color:u.role===role?"#fff":"#333"}} onClick={() => handleRoleChange(u._id,role)}>{role}</button>
                  ))}
                  <button style={{...styles.roleBtn,background:"#B43232",color:"#fff",marginLeft:"auto"}} onClick={() => handleDeleteUser(u._id,u.email)}>Delete</button>
                </div>
              </div>
            ))
          }
        </Section>
      </>}

      {tab === "ads" && <>
        <Section title="📺 Create New Ad">
          <div style={styles.formGrid}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Machine ID</label>
              <select style={styles.input} value={adForm.machineId} onChange={e => setAdForm({...adForm,machineId:e.target.value})}>
                <option value="ALL">All Machines</option>
                {machines.map(m => (
                  <option key={m.machineId} value={m.machineId}>
                    {m.machineId}{m.location ? ` — ${m.location}` : ""}
                  </option>
                ))}
              </select>
            </div>
            <div style={styles.formGroup}><label style={styles.label}>Advertiser Name</label><input style={styles.input} value={adForm.title} onChange={e => setAdForm({...adForm,title:e.target.value})} placeholder="e.g. Amul, Rebloc" /></div>
            <div style={styles.formGroup}><label style={styles.label}>Campaign Notes</label><input style={styles.input} value={adForm.text} onChange={e => setAdForm({...adForm,text:e.target.value})} placeholder="Admin only notes" /></div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Image URL</label>
              <input style={styles.input} value={adForm.imageUrl} onChange={e => setAdForm({...adForm,imageUrl:e.target.value})} placeholder="https://... or upload below" />
              <div style={{display:"flex",alignItems:"center",gap:"10px",marginTop:"4px"}}>
                <input type="file" accept="image/*" onChange={handleImageUpload} disabled={uploading} style={{fontSize:"13px"}} />
                {uploading && <span style={{fontSize:"12px",color:"#888"}}>Uploading...</span>}
              </div>
              {adForm.imageUrl && <img src={adForm.imageUrl} alt="preview" style={styles.adImg} />}
            </div>
            <div style={styles.formGroup}><label style={styles.label}>Start Time</label><input style={styles.input} type="datetime-local" value={adForm.startTime} onChange={e => setAdForm({...adForm,startTime:e.target.value})} /></div>
            <div style={styles.formGroup}><label style={styles.label}>End Time</label><input style={styles.input} type="datetime-local" value={adForm.endTime} onChange={e => setAdForm({...adForm,endTime:e.target.value})} /></div>
            <div style={styles.formGroup}><label style={styles.label}>Duration per cycle (seconds)</label><input style={styles.input} type="number" value={adForm.durationSec} onChange={e => setAdForm({...adForm,durationSec:Number(e.target.value)})} /></div>
          </div>
          <button style={styles.createBtn} onClick={handleCreateAd}>Create Ad</button>
          {adMsg && <p style={{marginTop:"10px",color:adMsg.startsWith("✅")?"#1a6b3c":"#B43232"}}>{adMsg}</p>}
        </Section>
        <Section title={selectedMachineId ? `📋 Scheduled Ads — ${selectedMachineId}` : "📋 Scheduled Ads"}>
          {scopedAds.length === 0 ? <p style={styles.empty}>No ads {selectedMachineId ? "for this machine" : "created"} yet.</p>
            : scopedAds.map(a => (
              <div key={a._id} style={styles.adCard}>
                <div style={styles.adTop}>
                  <div><span style={styles.adId}>{a.adId}</span><span style={styles.adMachine}> · {a.machineId}</span></div>
                  <div style={styles.adRight}>
                    <span style={{...styles.pill,background:a.active?"#1a6b3c":"#888"}}>{a.active?"active":"inactive"}</span>
                    <button style={styles.deleteBtn} onClick={() => handleDeleteAd(a.adId)}>Delete</button>
                  </div>
                </div>
                <p style={styles.adTitle}>{a.title}</p>
                {a.text && <p style={styles.adText}>{a.text}</p>}
                {a.imageUrl && <img src={a.imageUrl} alt="ad" style={styles.adImg} onError={e => e.target.style.display="none"} />}
                <p style={styles.adTime}>{new Date(a.startTime).toLocaleString("en-IN")} → {new Date(a.endTime).toLocaleString("en-IN")} · {a.durationSec}s</p>
              </div>
            ))
          }
        </Section>
      </>}

      {tab === "payouts" && <>
        <Section title="💸 Payout Requests">
          {payouts.length === 0 ? <p style={styles.empty}>No payout requests yet.</p>
            : payouts.map(p => (
              <div key={p._id} style={styles.payoutCard}>
                <div style={styles.payoutTop}>
                  <div><p style={styles.payoutEmail}>{p.email}</p><p style={styles.payoutUpi}>UPI: {p.upiId}</p></div>
                  <div style={styles.payoutRight}><span style={styles.payoutAmount}>{p.amountRs} credits</span><StatusPill status={p.status} /></div>
                </div>
                <p style={styles.payoutMeta}>{p.credits} credits · Requested {new Date(p.requestedAt).toLocaleString("en-IN")}</p>
                {p.status === "pending" && (
                  <div style={styles.payoutActions}>
                    <button style={{...styles.actionBtn,background:"#1a6b3c"}} onClick={() => handlePayoutUpdate(p._id,"paid")}>✅ Mark Paid</button>
                    <button style={{...styles.actionBtn,background:"#B43232"}} onClick={() => handlePayoutUpdate(p._id,"rejected")}>❌ Reject</button>
                  </div>
                )}
                {p.processedAt && <p style={styles.payoutMeta}>Processed: {new Date(p.processedAt).toLocaleString("en-IN")}</p>}
              </div>
            ))
          }
        </Section>
      </>}

      {tab === "feedback"  && <FeedbackTab  token={token()} />}
      {tab === "energy"    && <EnergyTab    token={token()} machineId={selectedMachineId} />}
      {tab === "analytics" && <AnalyticsTab token={token()} />}

      {tab === "reports" && <>
        <Section title="📥 Download Reports (CSV)">
          <div style={{display:"flex",gap:"16px",flexWrap:"wrap",marginBottom:"20px",alignItems:"flex-end"}}>
            <div style={styles.formGroup}><label style={styles.label}>From Date</label><input style={styles.input} type="date" value={reportFrom} onChange={e => setReportFrom(e.target.value)} /></div>
            <div style={styles.formGroup}><label style={styles.label}>To Date</label><input style={styles.input} type="date" value={reportTo} onChange={e => setReportTo(e.target.value)} /></div>
            <p style={{fontSize:"12px",color:"#aaa",margin:"0 0 4px"}}>Leave dates blank to download all records.</p>
          </div>
          <div style={{display:"flex",gap:"12px",flexWrap:"wrap"}}>
            <button style={{...styles.createBtn,background:"#1a6b3c"}} onClick={() => downloadCSV("weights")}>⬇ Weight Records CSV</button>
            <button style={{...styles.createBtn,background:"#2E4A3A"}} onClick={() => downloadCSV("pickups")}>⬇ Pickups CSV</button>
            <button style={{...styles.createBtn,background:"#C49A6C"}} onClick={() => downloadCSV("payouts")}>⬇ Payouts CSV (all machines)</button>
          </div>
          {selectedMachineId && (
            <p style={{fontSize:"12px",color:"#999",marginTop:"10px"}}>
              Weight Records and Pickups will be filtered to <strong>{selectedMachineId}</strong>.
              Payouts always include all machines, since credits are pooled across a user's whole account.
            </p>
          )}
        </Section>
      </>}
    </div></div>
  );
}

function KPICard({ label, value, color }) {
  const isDefault = color === "#2E4A3A";
  const cardStyle = isDefault
    ? styles.kpiCard
    : { ...styles.kpiCard, borderLeft: `3px solid ${color}` };
  return (
    <div style={cardStyle}>
      <p style={styles.kpiLabel}>{label}</p>
      <p style={{ ...styles.kpiValue, color: isDefault ? "#1E3B2C" : color }}>{value}</p>
    </div>
  );
}
function Section({ title, children }) {
  return <div style={styles.section}><h2 style={styles.sectionTitle}>{title}</h2>{children}</div>;
}
function Stat({ label, value }) {
  return <div style={styles.stat}><p style={styles.statLabel}>{label}</p><p style={styles.statValue}>{value}</p></div>;
}
function FillBar({ fill }) {
  const color = fill >= 80 ? "#B43232" : fill >= 50 ? "#C49A6C" : "#2E4A3A";
  return <div style={styles.fillBg}><div style={{...styles.fillBar,width:fill+"%",background:color}} /></div>;
}
function StatusPill({ status }) {
  const colors = { online:"#1a6b3c",offline:"#888",full:"#B43232",error:"#B43232",pending:"#C49A6C",assigned:"#2E4A3A",collected:"#1a6b3c",paid:"#1a6b3c",rejected:"#B43232",user:"#2E4A3A",operator:"#BA7517",admin:"#534AB7",rhino:"#0d5c4a" };
  return <span style={{...styles.pill,background:colors[status]||"#888"}}>{status}</span>;
}

const styles = {
  bg:{minHeight:"100vh",background:"#f3f2ee",padding:"32px 24px"},
  container:{maxWidth:"920px",margin:"0 auto"},
  header:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"28px"},
  title:{margin:0,fontSize:"24px",color:"#1E3B2C",fontWeight:700,letterSpacing:"-0.01em"},
  sub:{margin:"5px 0 0",color:"#8a8a82",fontSize:"13px"},
  logoutBtn:{padding:"9px 18px",background:"transparent",color:"#666",border:"1px solid #ddd",borderRadius:"8px",cursor:"pointer",fontSize:"13px",fontWeight:500},

  machineSelectorBar:{display:"flex",alignItems:"center",gap:"12px",flexWrap:"wrap",background:"#fff",borderRadius:"12px",padding:"14px 18px",marginBottom:"14px",border:"1px solid #eae8e1"},
  machineSelectorLabel:{fontSize:"11px",color:"#999",fontWeight:600,textTransform:"uppercase",letterSpacing:"0.6px"},
  machineSelectorInput:{padding:"8px 12px",border:"1px solid #e0ded6",borderRadius:"8px",fontSize:"13px",outline:"none",minWidth:"250px",background:"#fafaf7"},
  machineSelectorActive:{display:"flex",alignItems:"center",gap:"10px",fontSize:"13px",color:"#1E3B2C",fontWeight:600,marginLeft:"auto"},
  scopeNote:{fontSize:"12px",color:"#8a6d3b",background:"#fdf9f2",border:"1px solid #f0e0c8",borderRadius:"10px",padding:"10px 16px",marginBottom:"28px",lineHeight:1.5},
  clearScopeBtn:{marginLeft:"10px",padding:"3px 10px",background:"#fff",border:"1px solid #C49A6C",color:"#8a6d3b",borderRadius:"6px",cursor:"pointer",fontSize:"11px",fontWeight:600},

  // KPIs are grouped into labeled clusters instead of one undifferentiated
  // grid, so related numbers (machines, activity, money) read together.
  kpiGroup:{marginBottom:"20px"},
  kpiGroupLabel:{fontSize:"11px",color:"#a3a29a",fontWeight:600,textTransform:"uppercase",letterSpacing:"0.6px",margin:"0 0 10px 2px"},
  kpiGrid:{display:"grid",gridTemplateColumns:"repeat(auto-fit, minmax(140px, 1fr))",gap:"10px"},
  kpiCard:{background:"#fff",borderRadius:"12px",padding:"16px 18px",border:"1px solid #eae8e1"},
  kpiLabel:{margin:"0 0 6px",color:"#999",fontSize:"11px",textTransform:"uppercase",letterSpacing:"0.4px"},
  kpiValue:{margin:0,fontSize:"22px",fontWeight:700,letterSpacing:"-0.01em"},

  tabRow:{display:"flex",gap:"6px",marginBottom:"28px",flexWrap:"wrap",background:"#e9e7e0",padding:"5px",borderRadius:"12px",width:"fit-content"},
  tabBtn:{padding:"9px 16px",border:"none",borderRadius:"8px",background:"transparent",cursor:"pointer",fontSize:"13px",fontWeight:500,color:"#767569"},
  tabActive:{background:"#fff",color:"#1E3B2C",boxShadow:"0 1px 3px rgba(0,0,0,0.08)"},
  tabScopedDot:{display:"inline-block",width:"6px",height:"6px",borderRadius:"50%",background:"#C49A6C",marginLeft:"6px",verticalAlign:"middle"},

  section:{background:"#fff",borderRadius:"14px",padding:"24px",marginBottom:"20px",border:"1px solid #eae8e1"},
  sectionTitle:{margin:"0 0 18px",fontSize:"15px",color:"#1E3B2C",fontWeight:600},
  empty:{color:"#a3a29a",fontSize:"13px",padding:"8px 0"},

  approvalCard:{border:"1px solid #f0e0c8",background:"#fdf9f2",borderRadius:"12px",padding:"16px",marginBottom:"10px"},
  approvalTop:{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:"8px",marginBottom:"6px"},
  approvalProposed:{color:"#8a6d3b",fontWeight:600,fontSize:"13px"},
  approvalMeta:{margin:"4px 0 12px",fontSize:"12px",color:"#b3a58c"},
  approvalActions:{display:"flex",gap:"8px"},

  machineCard:{border:"1px solid #eae8e1",borderRadius:"12px",padding:"18px",marginBottom:"12px"},
  machineTop:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"10px"},
  machineId:{fontWeight:700,color:"#1E3B2C",fontSize:"15px",letterSpacing:"-0.01em"},
  machineLoc:{margin:"0 0 16px",color:"#767569",fontSize:"13px",display:"flex",alignItems:"center",gap:"10px"},
  editLocationBtn:{padding:"3px 10px",background:"#f5f4ef",color:"#2E4A3A",border:"1px solid #e0ded6",borderRadius:"6px",cursor:"pointer",fontSize:"11px",fontWeight:600},
  deleteMachineBtn:{padding:"3px 10px",background:"transparent",color:"#B43232",border:"1px solid #f0c7c7",borderRadius:"6px",cursor:"pointer",fontSize:"11px",fontWeight:600},
  locationEditRow:{display:"flex",gap:"8px",alignItems:"center",marginBottom:"14px",flexWrap:"wrap"},
  locationInput:{flex:1,minWidth:"200px",padding:"9px 12px",border:"1px solid #C49A6C",borderRadius:"8px",fontSize:"13px",outline:"none"},
  locationSaveBtn:{padding:"9px 16px",background:"#1a6b3c",color:"#fff",border:"none",borderRadius:"8px",cursor:"pointer",fontSize:"12px",fontWeight:600},
  locationCancelBtn:{padding:"9px 16px",background:"#f5f4ef",color:"#767569",border:"none",borderRadius:"8px",cursor:"pointer",fontSize:"12px",fontWeight:600},
  locationMsg:{margin:"0 0 12px",fontSize:"12px",color:"#B43232"},
  machineStats:{display:"flex",gap:"22px",marginBottom:"14px",flexWrap:"wrap",paddingBottom:"14px",borderBottom:"1px solid #f2f1eb"},
  stat:{textAlign:"left"},
  statLabel:{margin:0,fontSize:"10px",color:"#a3a29a",textTransform:"uppercase",letterSpacing:"0.4px"},
  statValue:{margin:"3px 0 0",fontSize:"15px",fontWeight:600,color:"#1E3B2C"},
  fillBg:{height:"6px",background:"#f0efe9",borderRadius:"3px",overflow:"hidden",marginBottom:"10px"},
  fillBar:{height:"100%",borderRadius:"3px",transition:"width 0.5s"},
  alertBadge:{color:"#fff",fontSize:"11px",padding:"4px 10px",borderRadius:"6px",marginBottom:"6px",display:"inline-block",marginRight:"6px",fontWeight:500},
  heartbeat:{margin:"10px 0 0",fontSize:"11px",color:"#c2c1b8"},

  pickupRow:{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"13px 0",borderBottom:"1px solid #f2f1eb"},
  pickupId:{fontWeight:600,color:"#1E3B2C",fontSize:"13px"},pickupMachine:{color:"#a3a29a",fontSize:"12px"},
  weightRow:{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"13px 0",borderBottom:"1px solid #f2f1eb"},
  mfid:{fontWeight:600,color:"#1E3B2C",fontSize:"13px"},weightMat:{color:"#a3a29a",fontSize:"12px"},
  weightRight:{display:"flex",gap:"14px",alignItems:"center"},weightKg:{fontWeight:600,color:"#1E3B2C",fontSize:"13px"},weightCo2:{color:"#1a6b3c",fontSize:"12px"},

  userCard:{border:"1px solid #eae8e1",borderRadius:"12px",padding:"16px",marginBottom:"10px"},
  userTop:{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"12px"},
  userEmail:{margin:"0 0 4px",fontWeight:600,color:"#1E3B2C",fontSize:"13px"},userMeta:{margin:0,color:"#a3a29a",fontSize:"12px"},
  userActions:{display:"flex",alignItems:"center",gap:"8px",flexWrap:"wrap"},roleLabel:{fontSize:"12px",color:"#a3a29a",marginRight:"4px"},
  roleBtn:{padding:"6px 13px",border:"1px solid #e0ded6",borderRadius:"7px",cursor:"pointer",fontSize:"12px",fontWeight:600},

  formGrid:{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:"16px",marginBottom:"20px"},
  formGroup:{display:"flex",flexDirection:"column",gap:"7px"},
  label:{fontSize:"11px",color:"#8a8a82",fontWeight:600,textTransform:"uppercase",letterSpacing:"0.4px"},
  input:{padding:"10px 12px",border:"1px solid #e0ded6",borderRadius:"9px",fontSize:"13px",outline:"none",background:"#fafaf7"},
  createBtn:{padding:"12px 22px",background:"#2E4A3A",color:"#fff",border:"none",borderRadius:"10px",cursor:"pointer",fontSize:"13px",fontWeight:600},

  adCard:{border:"1px solid #eae8e1",borderRadius:"12px",padding:"16px",marginBottom:"12px"},
  adTop:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"8px"},
  adId:{fontWeight:700,color:"#1E3B2C",fontSize:"13px"},adMachine:{color:"#a3a29a",fontSize:"12px"},
  adRight:{display:"flex",gap:"8px",alignItems:"center"},adTitle:{margin:"0 0 5px",fontWeight:600,color:"#333",fontSize:"14px"},
  adText:{margin:"0 0 8px",color:"#767569",fontSize:"12px"},adImg:{width:"100%",maxHeight:"120px",objectFit:"cover",borderRadius:"9px",marginBottom:"8px"},
  adTime:{margin:0,fontSize:"11px",color:"#c2c1b8"},deleteBtn:{padding:"4px 12px",background:"transparent",color:"#B43232",border:"1px solid #f0c7c7",borderRadius:"7px",cursor:"pointer",fontSize:"12px"},

  payoutCard:{border:"1px solid #eae8e1",borderRadius:"12px",padding:"16px",marginBottom:"12px"},
  payoutTop:{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"8px"},
  payoutEmail:{margin:"0 0 3px",fontWeight:600,color:"#1E3B2C",fontSize:"13px"},payoutUpi:{margin:0,color:"#a3a29a",fontSize:"12px"},
  payoutRight:{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:"6px"},
  payoutAmount:{fontWeight:700,fontSize:"17px",color:"#1E3B2C"},payoutMeta:{margin:"5px 0 0",color:"#c2c1b8",fontSize:"12px"},
  payoutActions:{display:"flex",gap:"10px",marginTop:"12px"},

  actionBtn:{padding:"9px 16px",color:"#fff",border:"none",borderRadius:"9px",cursor:"pointer",fontSize:"12px",fontWeight:600},
  pill:{color:"#fff",fontSize:"10px",padding:"4px 10px",borderRadius:"20px",fontWeight:600},
  loading:{display:"flex",justifyContent:"center",alignItems:"center",height:"100vh",color:"#1E3B2C",fontSize:"15px"},
};

export default AdminDashboard;

function FeedbackTab({ token }) {
  const [feedbacks, setFeedbacks] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    fetch("https://smart-bin-backend-zygj.onrender.com/api/feedback", { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(data => { setFeedbacks(Array.isArray(data) ? data : []); setLoading(false); }).catch(() => setLoading(false));
  }, [token]);
  const stars = n => "★".repeat(n) + "☆".repeat(5-n);
  const avgRating = feedbacks.length ? (feedbacks.reduce((s,f) => s+f.rating, 0)/feedbacks.length).toFixed(1) : "—";
  if (loading) return <p style={{padding:"20px",color:"#aaa"}}>Loading feedback...</p>;
  return (
    <Section title="💬 User Feedback">
      {feedbacks.length === 0 ? <p style={{color:"#aaa",fontSize:"14px"}}>No feedback submitted yet.</p>
        : <>
          <div style={{display:"flex",gap:"24px",marginBottom:"20px",padding:"16px",background:"#f0f4f0",borderRadius:"10px"}}>
            <div style={{textAlign:"center"}}><div style={{fontSize:"32px",fontWeight:"700",color:"#1E3B2C"}}>{avgRating}</div><div style={{fontSize:"13px",color:"#888"}}>Average Rating</div></div>
            <div style={{textAlign:"center"}}><div style={{fontSize:"32px",fontWeight:"700",color:"#1E3B2C"}}>{feedbacks.length}</div><div style={{fontSize:"13px",color:"#888"}}>Total Responses</div></div>
          </div>
          {feedbacks.map((f,i) => (
            <div key={i} style={{padding:"14px",marginBottom:"10px",background:"#fff",borderRadius:"10px",border:"1px solid #eee"}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:"6px"}}>
                <span style={{color:"#C49A6C",fontSize:"18px",letterSpacing:"2px"}}>{stars(f.rating)}</span>
                <span style={{fontSize:"12px",color:"#aaa"}}>{new Date(f.createdAt).toLocaleDateString("en-IN",{day:"numeric",month:"short",year:"numeric"})}</span>
              </div>
              <p style={{margin:"0 0 6px",fontSize:"14px",color:"#333"}}>{f.message}</p>
              <span style={{fontSize:"12px",color:"#888"}}>{f.email}</span>
            </div>
          ))}
        </>
      }
    </Section>
  );
}

function EnergyTab({ token, machineId }) {
  const [sessions, setSessions] = React.useState([]);
  const [daily, setDaily] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [showDetail, setShowDetail] = React.useState(false);
  const [detailDate, setDetailDate] = React.useState("");
  const API = "https://smart-bin-backend-zygj.onrender.com";
  React.useEffect(() => {
    setLoading(true);
    const machineParam = machineId ? `&machineId=${encodeURIComponent(machineId)}` : "";
    Promise.all([
      fetch(`${API}/api/logs/sessions?limit=200${machineParam}`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()),
      fetch(`${API}/api/logs/daily?days=14${machineParam}`,      { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()),
    ]).then(([s, d]) => { setSessions(Array.isArray(s)?s:[]); setDaily(Array.isArray(d)?d:[]); setLoading(false); }).catch(() => setLoading(false));
  }, [token, machineId]);
  const fmt = (sec) => { const h=Math.floor(sec/3600); const m=Math.floor((sec%3600)/60); return h>0?`${h}h ${m}m`:`${m}m`; };
  if (loading) return <p style={{padding:"20px",color:"#aaa"}}>Loading energy data...</p>;
  return (
    <div>
      <Section title={machineId ? `⚡ Daily Energy Summary — ${machineId} (Last 14 Days)` : "⚡ Daily Energy Summary (Last 14 Days)"}>
        {daily.length === 0 ? <p style={{color:"#aaa",fontSize:"14px"}}>No daily logs yet.</p>
          : <table style={{width:"100%",borderCollapse:"collapse",fontSize:"13px"}}>
            <thead><tr style={{background:"#1E3B2C",color:"#fff"}}>
              {["Date","Uptime","Downtime","Sessions","Motor (Wh)","Idle (Wh)","Total (Wh)","Weight (kg)"].map(h => <th key={h} style={{padding:"8px 10px",textAlign:"left"}}>{h}</th>)}
            </tr></thead>
            <tbody>{daily.map((d,i) => (
              <tr key={i} style={{background:i%2===0?"#fafafa":"#fff",borderBottom:"1px solid #eee"}}>
                <td style={{padding:"7px 10px",fontWeight:"600",color:"#1E3B2C"}}>{d.date}</td>
                <td style={{padding:"7px 10px"}}>{fmt(d.uptimeSec||0)}</td>
                <td style={{padding:"7px 10px",color:"#aaa"}}>{fmt(d.downtimeSec||0)}</td>
                <td style={{padding:"7px 10px"}}>{d.totalSessions||0}</td>
                <td style={{padding:"7px 10px",color:"#1a6b3c"}}>{(d.totalMotorEnergyWh||0).toFixed(2)}</td>
                <td style={{padding:"7px 10px",color:"#888"}}>{(d.idleEnergyWh||0).toFixed(2)}</td>
                <td style={{padding:"7px 10px",fontWeight:"600"}}>{(d.totalEnergyWh||0).toFixed(2)}</td>
                <td style={{padding:"7px 10px"}}>{(d.totalWeightKg||0).toFixed(3)}</td>
              </tr>
            ))}</tbody>
          </table>
        }
      </Section>

      <Section title={machineId ? `🔬 Evidence Data — ${machineId}` : "🔬 Evidence Data — Motor Behaviour Analysis"}>
        <p style={{fontSize:"12px",color:"#888",marginBottom:"12px"}}>
          Data collected per session for load cell placement decision. Empty time = motor running with no plastic. Overload time = current dangerously high before jam. First load = delay before plastic was detected.
        </p>

        {sessions.length > 0 && (() => {
          const withData = sessions.filter(s => s.emptyTimeSec > 0 || s.timeToFirstLoadSec > 0 || s.overloadTimeSec > 0);
          const avg = (arr, key) => arr.length ? (arr.reduce((s,i) => s + (i[key]||0), 0) / arr.length).toFixed(1) : "—";
          const avgEmpty     = avg(sessions, "emptyTimeSec");
          const avgOverload  = avg(sessions, "overloadTimeSec");
          const avgFirstLoad = avg(sessions, "timeToFirstLoadSec");
          const totalJams    = sessions.reduce((s,i) => s + (i.jamCount||0), 0);
          const allJamDurs   = sessions.flatMap(s => s.jamDurations||[]);
          const avgJamDur    = allJamDurs.length ? (allJamDurs.reduce((a,b)=>a+b,0)/allJamDurs.length).toFixed(1) : "—";

          const verdict = (val, low, high) => {
            if (val === "—") return { icon:"⬜", color:"#aaa", text:"No data yet" };
            const n = parseFloat(val);
            if (n <= low)  return { icon:"✅", color:"#1a6b3c", text:"Good" };
            if (n <= high) return { icon:"⚠️", color:"#C49A6C", text:"Monitor" };
            return { icon:"🔴", color:"#B43232", text:"Action needed" };
          };

          const rows = [
            { label:"Avg Empty Time",     value: avgEmpty+"s",    v: verdict(avgEmpty, 10, 30),     note:"Motor running with no plastic" },
            { label:"Avg Overload Time",  value: avgOverload+"s", v: verdict(avgOverload, 1, 5),    note:"High current before jam" },
            { label:"Avg First Load",     value: avgFirstLoad+"s",v: verdict(avgFirstLoad, 5, 20),  note:"Delay before plastic detected" },
            { label:"Total Jams",         value: totalJams,       v: verdict(totalJams, 2, 10),     note:"Across all sessions" },
            { label:"Avg Jam Duration",   value: avgJamDur+"s",   v: verdict(avgJamDur, 5, 10),     note:"Time to clear each jam" },
          ];

          return (
            <div style={{background:"#f9f9f9",borderRadius:"10px",padding:"16px",marginBottom:"20px"}}>
              <p style={{fontWeight:"600",color:"#1E3B2C",fontSize:"14px",marginBottom:"12px"}}>📊 Auto Summary — {sessions.length} sessions analysed</p>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:"10px"}}>
                {rows.map((r,i) => (
                  <div key={i} style={{background:"#fff",borderRadius:"8px",padding:"12px",border:"1px solid #eee",borderLeft:`4px solid ${r.v.color}`}}>
                    <div style={{fontSize:"11px",color:"#888",marginBottom:"4px"}}>{r.label}</div>
                    <div style={{fontSize:"22px",fontWeight:"700",color:r.v.color}}>{r.value}</div>
                    <div style={{fontSize:"11px",marginTop:"4px"}}>
                      <span>{r.v.icon} {r.v.text}</span>
                      <span style={{color:"#aaa",marginLeft:"6px"}}>— {r.note}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })()}
        {sessions.length === 0 ? <p style={{color:"#aaa",fontSize:"14px"}}>No session logs yet.</p>
          : (
            <div>
              <div style={{display:"flex",alignItems:"center",gap:"12px",flexWrap:"wrap",marginTop:"4px"}}>
                <button
                  onClick={() => setShowDetail(!showDetail)}
                  style={{padding:"9px 16px",background:showDetail?"#2E4A3A":"#f5f4ef",color:showDetail?"#fff":"#2E4A3A",border:"1px solid #e0ded6",borderRadius:"9px",cursor:"pointer",fontSize:"12px",fontWeight:600}}
                >
                  {showDetail ? "Hide session-by-session detail" : `Show session-by-session detail (${sessions.length})`}
                </button>
                {showDetail && (
                  <>
                    <label style={{fontSize:"12px",color:"#8a8a82"}}>Filter by date:</label>
                    <input
                      type="date"
                      value={detailDate}
                      onChange={e => setDetailDate(e.target.value)}
                      style={{padding:"7px 10px",border:"1px solid #e0ded6",borderRadius:"7px",fontSize:"12px",outline:"none"}}
                    />
                    {detailDate && (
                      <button
                        onClick={() => setDetailDate("")}
                        style={{padding:"7px 12px",background:"transparent",color:"#8a8a82",border:"1px solid #e0ded6",borderRadius:"7px",cursor:"pointer",fontSize:"11px"}}
                      >
                        Clear date
                      </button>
                    )}
                  </>
                )}
              </div>

              {showDetail && (() => {
                const filtered = detailDate
                  ? sessions.filter(s => s.sessionStart && s.sessionStart.slice(0,10) === detailDate)
                  : sessions;
                if (filtered.length === 0) {
                  return <p style={{color:"#aaa",fontSize:"13px",marginTop:"14px"}}>No sessions on that date.</p>;
                }
                return (
                  <div style={{overflowX:"auto",marginTop:"14px"}}>
                    <table style={{width:"100%",borderCollapse:"collapse",fontSize:"12px",minWidth:"900px"}}>
                      <thead><tr style={{background:"#1E3B2C",color:"#fff"}}>
                        {["Start Time","Duration","Avg (A)","Peak (A)","Jams","End Reason","Weight","Empty (s)","Overload (s)","First Load (s)","Jam Durations"].map(h => (
                          <th key={h} style={{padding:"8px 10px",textAlign:"left",whiteSpace:"nowrap"}}>{h}</th>
                        ))}
                      </tr></thead>
                      <tbody>{filtered.map((s,i) => (
                        <tr key={i} style={{background:i%2===0?"#fafafa":"#fff",borderBottom:"1px solid #eee"}}>
                          <td style={{padding:"7px 10px",color:"#1E3B2C",fontWeight:"600",whiteSpace:"nowrap"}}>
                            {new Date(s.sessionStart).toLocaleString("en-IN",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"})}
                          </td>
                          <td style={{padding:"7px 10px"}}>{s.durationSec||0}s</td>
                          <td style={{padding:"7px 10px"}}>{(s.avgCurrentA||0).toFixed(3)}A</td>
                          <td style={{padding:"7px 10px"}}>{(s.peakCurrentA||0).toFixed(3)}A</td>
                          <td style={{padding:"7px 10px",color:s.jamCount>0?"#B43232":"#888"}}>{s.jamCount||0}</td>
                          <td style={{padding:"7px 10px",fontSize:"11px",color:s.endReason==="idle_detection"?"#1a6b3c":s.endReason==="safety_timeout"?"#C49A6C":"#B43232"}}>{s.endReason}</td>
                          <td style={{padding:"7px 10px"}}>{(s.weightKg||0).toFixed(3)}kg</td>
                          <td style={{padding:"7px 10px",color:"#C49A6C",fontWeight:"600"}}>{s.emptyTimeSec||0}s</td>
                          <td style={{padding:"7px 10px",color:"#B43232",fontWeight:"600"}}>{s.overloadTimeSec||0}s</td>
                          <td style={{padding:"7px 10px"}}>{s.timeToFirstLoadSec||0}s</td>
                          <td style={{padding:"7px 10px",fontSize:"11px",color:"#888"}}>{(s.jamDurations||[]).join(", ")||"—"}</td>
                        </tr>
                      ))}</tbody>
                    </table>
                  </div>
                );
              })()}
            </div>
          )
        }
        <p style={{fontSize:"12px",color:"#aaa",marginTop:"12px"}}>
          Motor energy: √3 × 415V × avg current × power factor (0.85) × session duration.<br/>
          Idle estimate: Pi 4B ~6W + display ~14W = <strong>~20W</strong> (not measured directly).
        </p>
      </Section>
    </div>
  );
}

function AnalyticsTab({ token }) {
  const [data, setData] = React.useState(null);
  const [hourly, setHourly] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const API = "https://smart-bin-backend-zygj.onrender.com";
  React.useEffect(() => {
    const today = new Date().toISOString().slice(0,10);
    Promise.all([
      fetch(`${API}/api/analytics/overview`,{headers:{Authorization:`Bearer ${token}`}}).then(r=>r.json()),
      fetch(`${API}/api/analytics/hourly?date=${today}`,{headers:{Authorization:`Bearer ${token}`}}).then(r=>r.json()),
    ]).then(([overview,hr]) => { setData(overview); setHourly(Array.isArray(hr)?hr:[]); setLoading(false); }).catch(() => setLoading(false));
  }, [token]);
  if (loading) return <p style={{padding:"20px",color:"#aaa"}}>Loading analytics...</p>;
  if (!data)   return <p style={{padding:"20px",color:"#aaa"}}>No data yet.</p>;
  const { throughput, users, sessionMetrics, uptime, dailyTrend } = data;
  const kpiStyle = (color) => ({background:"#fff",borderRadius:"12px",padding:"16px 20px",boxShadow:"0 1px 6px rgba(0,0,0,0.06)",borderTop:`3px solid ${color}`,minWidth:"140px",flex:"1"});
  const kpiVal = {fontSize:"26px",fontWeight:"700",color:"#1E3B2C"};
  const kpiLbl = {fontSize:"11px",color:"#aaa",marginTop:"2px"};
  const kpiSub = {fontSize:"12px",color:"#888",marginTop:"4px"};
  const maxBar = Math.max(...(dailyTrend||[]).map(d=>d.weightKg),1);
  return (
    <div>
      <Section title="📦 Throughput">
        <div style={{display:"flex",gap:"12px",flexWrap:"wrap",marginBottom:"20px"}}>
          <div style={kpiStyle("#1E3B2C")}><div style={kpiVal}>{(throughput.kgToday||0).toFixed(2)} kg</div><div style={kpiLbl}>Today</div><div style={kpiSub}>{throughput.sessToday||0} sessions · {(throughput.kgPerHour||0).toFixed(3)} kg/hr</div></div>
          <div style={kpiStyle("#C49A6C")}><div style={kpiVal}>{(throughput.kgWeek||0).toFixed(2)} kg</div><div style={kpiLbl}>Last 7 Days</div><div style={kpiSub}>{throughput.sessWeek||0} sessions</div></div>
          <div style={kpiStyle("#2E4A3A")}><div style={kpiVal}>{(throughput.kgMonth||0).toFixed(2)} kg</div><div style={kpiLbl}>Last 30 Days</div><div style={kpiSub}>{throughput.sessMonth||0} sessions</div></div>
          <div style={kpiStyle("#1a6b3c")}><div style={kpiVal}>{(throughput.kgAll||0).toFixed(2)} kg</div><div style={kpiLbl}>All Time</div><div style={kpiSub}>{throughput.sessAll||0} total sessions</div></div>
        </div>
        <p style={{fontSize:"12px",color:"#888",marginBottom:"8px"}}>Throughput by hour — today</p>
        <div style={{display:"flex",alignItems:"flex-end",gap:"3px",height:"80px",background:"#f9f9f9",padding:"8px",borderRadius:"8px"}}>
          {hourly.map((h,i) => (
            <div key={i} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center"}}>
              <div title={`${h.hour}:00 — ${h.weightKg.toFixed(3)}kg`} style={{width:"100%",background:h.weightKg>0?"#1E3B2C":"#eee",height:`${Math.max(2,(h.weightKg/maxBar)*60)}px`,borderRadius:"2px 2px 0 0",transition:"height 0.3s"}}/>
              {i%4===0&&<span style={{fontSize:"8px",color:"#aaa",marginTop:"2px"}}>{h.hour}</span>}
            </div>
          ))}
        </div>
        <p style={{fontSize:"12px",color:"#888",margin:"16px 0 8px"}}>Daily throughput — last 30 days (kg)</p>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:"12px",minWidth:"600px"}}>
            <thead><tr style={{background:"#1E3B2C",color:"#fff"}}>{["Date","Weight (kg)","Sessions"].map(h=><th key={h} style={{padding:"6px 10px",textAlign:"left"}}>{h}</th>)}</tr></thead>
            <tbody>{(dailyTrend||[]).slice().reverse().map((d,i)=>(
              <tr key={i} style={{background:i%2===0?"#fafafa":"#fff",borderBottom:"1px solid #eee"}}>
                <td style={{padding:"6px 10px",fontWeight:"600",color:"#1E3B2C"}}>{d._id}</td>
                <td style={{padding:"6px 10px"}}>{(d.weightKg||0).toFixed(3)}</td>
                <td style={{padding:"6px 10px"}}>{d.sessions||0}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      </Section>
      <Section title="👤 User Contribution">
        <div style={{display:"flex",gap:"12px",flexWrap:"wrap",marginBottom:"20px"}}>
          <div style={kpiStyle("#1E3B2C")}><div style={kpiVal}>{users.totalUsers||0}</div><div style={kpiLbl}>Registered Users</div></div>
          <div style={kpiStyle("#C49A6C")}><div style={kpiVal}>{(users.avgWeightKg||0).toFixed(3)} kg</div><div style={kpiLbl}>Avg Contribution / User</div><div style={kpiSub}>= total weight ÷ users</div></div>
          <div style={kpiStyle("#2E4A3A")}><div style={kpiVal}>{(users.maxWeightKg||0).toFixed(3)} kg</div><div style={kpiLbl}>Top User Weight</div></div>
          <div style={kpiStyle("#1a6b3c")}><div style={kpiVal}>{(users.avgCredits||0).toFixed(3)}</div><div style={kpiLbl}>Avg Credits / User</div></div>
        </div>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:"13px"}}>
          <thead><tr style={{background:"#1E3B2C",color:"#fff"}}>{["#","Email","Total Weight (kg)","Credits","Deposits"].map(h=><th key={h} style={{padding:"7px 10px",textAlign:"left"}}>{h}</th>)}</tr></thead>
          <tbody>{(users.topUsers||[]).map((u,i)=>(
            <tr key={i} style={{background:i%2===0?"#fafafa":"#fff",borderBottom:"1px solid #eee"}}>
              <td style={{padding:"7px 10px",color:"#C49A6C",fontWeight:"700"}}>{i+1}</td>
              <td style={{padding:"7px 10px",color:"#1E3B2C"}}>{u.email}</td>
              <td style={{padding:"7px 10px",fontWeight:"600"}}>{(u.totalWeight||0).toFixed(3)}</td>
              <td style={{padding:"7px 10px"}}>{(u.credits||0).toFixed(3)}</td>
              <td style={{padding:"7px 10px"}}>{u.plasticItems||0}</td>
            </tr>
          ))}</tbody>
        </table>
      </Section>
      <Section title="⚙️ Machine Performance">
        <div style={{display:"flex",gap:"12px",flexWrap:"wrap",marginBottom:"16px"}}>
          <div style={kpiStyle("#1E3B2C")}><div style={kpiVal}>{sessionMetrics.totalSessions||0}</div><div style={kpiLbl}>Total Sessions Logged</div></div>
          <div style={kpiStyle("#B43232")}><div style={kpiVal}>{sessionMetrics.totalJams||0}</div><div style={kpiLbl}>Total Jams</div><div style={kpiSub}>avg {(sessionMetrics.avgJamsPerSession||0).toFixed(2)} / session</div></div>
          <div style={kpiStyle("#C49A6C")}><div style={kpiVal}>{Math.round(sessionMetrics.avgDurationSec||0)}s</div><div style={kpiLbl}>Avg Session Duration</div></div>
          <div style={kpiStyle("#1a6b3c")}><div style={kpiVal}>{uptime.uptimePct||0}%</div><div style={kpiLbl}>Uptime (7 days)</div><div style={kpiSub}>= uptime ÷ (7 × 86400s) × 100</div></div>
        </div>
        <p style={{fontSize:"12px",color:"#888",marginBottom:"8px"}}>Session end reason breakdown</p>
        <div style={{display:"flex",gap:"12px",flexWrap:"wrap"}}>
          {[{label:"Idle Detection (normal)",val:sessionMetrics.idleDetection||0,color:"#1a6b3c"},{label:"Safety Timeout (meter off)",val:sessionMetrics.safetyTimeout||0,color:"#C49A6C"},{label:"Jam Abort (too many jams)",val:sessionMetrics.jamAbort||0,color:"#B43232"}].map((item,i)=>(
            <div key={i} style={{...kpiStyle(item.color),minWidth:"160px"}}>
              <div style={{...kpiVal,color:item.color}}>{item.val}</div>
              <div style={kpiLbl}>{item.label}</div>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
}